import * as Yup from 'yup';
import { telephoneValidation, postcodeValidation } from 'utils/form/validation';

export default Yup.object().shape({
  clubName: Yup.string().required('This field is required.'),
  postcode: postcodeValidation().required('This field is required.'),
  houseNumber: Yup.string().required('This field is required.'),
  addressLine1: Yup.string().notRequired(),
  addressLine2: Yup.string().notRequired(),
  city: Yup.string().required('This field is required.'),
  county: Yup.string().notRequired(),
  email: Yup.string().required('This field is required.'),
  telephoneNumber: telephoneValidation().required('This field is required.'),
  commissionTerms: Yup.string().required('This field is required.'),
});
